/**
 * Launch gates for pages that are built and reachable by URL but not yet
 * public. A staged slug renders normally for review, carries a noindex tag,
 * and is linked from nowhere.
 */

// ★ E27 LAUNCH GATE (Strategy HQ "portfolio-brand-architecture"). Member Pro
// replaces Alumni. Opened 2026-10-02: /programs/member-pro and
// /lets-talk/member-pro are public, and the /programs/alumni + /lets-talk/alumni
// 301s are in taker/public/_redirects. Checklist: docs/plans/member-pro-go-live.md
export const MEMBER_PRO_LIVE = true;

/** Slugs that must stay out of search until their launch gate opens. */
export const STAGED_SLUGS: ReadonlySet<string> = new Set(MEMBER_PRO_LIVE ? [] : ['member-pro']);
